import { AddPanelPositionOptions, DockviewApi } from "dockview";
import I18n from "lib/I18n";

export function showExplorer(api: DockviewApi) {
  // 最も左に表示
  return api.addPanel({
    id: "explorer",
    component: "explorer",
    title: I18n.t("bigquery_query_viewer.label.explorer"),
    initialWidth: 300,
    position: {
      direction: "left",
    },
  });
}

export function showProblem(api: DockviewApi) {
  // デフォルトではeditorsグループの下に表示
  let position: AddPanelPositionOptions = {
    direction: "below",
    referenceGroup: "editors",
  };
  // jobのパネルがあれば同じところに重ねる
  const jobPanel = api.panels.find((_) => _.id == "job");
  if (jobPanel) {
    position = { referencePanel: "job" };
  }

  return api.addPanel({
    id: "problem",
    component: "problem",
    title: I18n.t("bigquery_query_viewer.label.problem"),
    initialHeight: 180,
    position,
  });
}

export function showJob(api: DockviewApi, inactive = false) {
  // デフォルトではeditorsグループの下に表示
  let position: AddPanelPositionOptions = {
    direction: "below",
    referenceGroup: "editors",
  };
  // problemのパネルがあれば同じところに重ねる
  const problemPanel = api.panels.find((_) => _.id == "problem");
  if (problemPanel) {
    position = { referencePanel: "problem" };
  }
  return api.addPanel({
    id: "job",
    component: "job",
    title: I18n.t("bigquery_query_viewer.label.job"),
    position,
    inactive,
  });
}

export function showChat(api: DockviewApi) {
  // 最も右に表示
  return api.addPanel({
    id: "chat",
    component: "chat",
    title: I18n.t("bigquery_query_viewer.label.chat"),
    initialWidth: 400,
    position: {
      direction: "right",
    },
  });
}
